// Copyright (c) 2016 Deere & Company

import './questionable-part-report.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found';
import QuestionablePart from '@deere/cps-it.warranty-model-factory/lib/questionable-part-search';
import QuestionablePartSearchCriteria from './questionable-part-search-criteria';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {getQuestionablePartColumnDefinitions} from '../report-services/column-definitions';

function updatePartSearchCriteria(partSearchEvent) {

    const partNumberValue = partSearchEvent.target.value;

    this.actions.updateQuestionablePartSearchCriteria(partNumberValue);

}

function fetchQuestionablePartValidity() {

    const questionablePartPostArgs = {
        partNumber: this.partNumberSearchCriteria
    };

    this.actions.fetchQuestionablePartReport(questionablePartPostArgs);

}

function resetPartSearchCriteria() {

    this.actions.resetQuestionablePart();
    this.actions.updateShowNoResultsFound(false);

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleExportToExcel() {

    const fileName = 'questionable-part';

    return exportToCSV(fileName, this.gridApi);

}

class QuestionablePartReport extends Component {

    componentWillMount() {

        this.props.actions.getReportLayouts('questionable-part');

    }

    componentDidUpdate(prevProps) {

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetQuestionablePart();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.resetReportVariant();

    }

    render() {

        const canExportToExcel = this.props.report.length > 0;

        return (
            <section className='questionable-part-report'>
                <h2 className='questionable-part-title'>
                    <FormattedMessage id='QUESTIONABLE_PART'/>
                    <FavoriteIcon
                        id='QUESTIONABLE_PART'
                        route={this.props.pathName}
                    />
                </h2>
                <QuestionablePartSearchCriteria
                    canExport={canExportToExcel}
                    onCriteriaReset={this.props::resetPartSearchCriteria}
                    onDownloadToExcel={this.props::handleExportToExcel}
                    onPartNumberSearch={this.props::updatePartSearchCriteria}
                    onPartSearchExecute={this.props::fetchQuestionablePartValidity}
                    partNumber={this.props.partNumberSearchCriteria}
                />
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='questionable-part'
                            />
                            <ReportGrid
                                columnDefs={getQuestionablePartColumnDefinitions()}
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                }
            </section>
        );

    }

}

QuestionablePartReport.displayName = 'QuestionablePartReport';
QuestionablePartReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    partNumberSearchCriteria: PropTypes.string.isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(QuestionablePart)),
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired
};

export default QuestionablePartReport;



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/components/questionable-part-report.js